<template>
  <form class="form main-content__form" v-if="directions">
    <div class="main-content__row">
      <router-link :to="{ name: 'events', params: { slug: direction.slug }}"
                   class="form__radio-date-wrap" v-for="direction in directions" v-bind:key="direction.id">
        <label v-bind:for="direction.id" class="form__radio-date-label">
          <div class="form__radio-date-left">
            <span class="form__radio-date-title">
              {{ direction.name }}
            </span>
            <!--<div class="form__radio-date-title form__radio-date-members">
              {{ direction.placeCount }}
            </div>-->
            <span class="form__radio-date-text">
              <span>
                {{ direction.dates }}
              </span>
            </span>
          </div>
        </label>
      </router-link>
    </div>
  </form>
  <div class="form main-content__form" v-else>
    <div class="main-content__row">
      Места закончились, следите за новостями
    </div>
  </div>
</template>

<script>
  import {mapState, mapActions, mapMutations} from 'vuex';

  export default {
    name: "Direction",
    mounted() {
      this.getDirections();
      this.setEvents([]);
      this.setMembersCount(1);
      this.setCurrentEventId('');
      this.setCurrentEvent({});
    },
    data: function () {
      return {}
    },
    methods: {
      ...mapActions([
        'getDirections'
      ]),
      ...mapMutations([
        'setEvents',
        'setMembersCount',
        'setCurrentEventId',
        'setCurrentEvent',
      ])
    },
    computed: {
      ...mapState([
        'directions',
      ]),
    }
  }
</script>

<style scoped>

</style>
